module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Krævet","track":"Required"}}